import LxcError from "~/core/models/LxcError.class";
import type { PkiConnectivityPayload } from "~/modules/pki/models/PkiConnectivityPayload.interface";
import pkiService from "~/modules/pki/services/pki.service";

export function useFetchPkiConnectivity() {
  const service = pkiService.getConnectivity.bind(pkiService);

  const isLoading = ref(false);
  const error: Ref<LxcError | null> = ref(null);
  const result: Ref<boolean | undefined> = ref();

  const success: ComputedRef<boolean | undefined> = computed(() => {
    return result.value && !isLoading.value;
  });

  const fail: ComputedRef<boolean> = computed(() => {
    return (result.value === false || error.value !== null) && !isLoading.value;
  });

  async function fetchConnectivity(pkiAlias: string) {
    isLoading.value = true;
    error.value = null;
    result.value = false;

    const response = await service(pkiAlias);

    if (LxcError.check(response)) {
      error.value = response;
    } else {
      result.value = response;
    }

    isLoading.value = false;
  }

  async function fetchConnectivityWithInfos(pki: PkiConnectivityPayload) {
    isLoading.value = true;
    error.value = null;
    result.value = false;

    const response = await pkiService.getConnectivityWithInfos(pki);

    if (LxcError.check(response)) {
      error.value = response;
    } else {
      result.value = response;
    }

    isLoading.value = false;
  }

  function resetState() {
    isLoading.value = false;
    error.value = null;
    result.value = undefined;
  }

  return {
    fetchConnectivity,
    fetchConnectivityWithInfos,
    isLoading,
    error,
    result,
    success,
    fail,
    resetState,
  };
}
